import {css} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {Message} from "@pg-design/message-module";
import {Tabs} from "@pg-design/tabs-module";

import {ALL_ROOMS, isAllRooms} from "../constants/rcn_rooms_filter";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {trackPricesCityButtonClick} from "../tracking/track_prices_city_button_click";
import {usePricesContext} from "./PricesContextFilterProvider";

const PRICE_STAT_TABS = [
    {title: "Średnia", value: "average"},
    {title: "Mediana", value: "median"}
] as const;

interface Props {
    location: PricesCityAnalyticsLocation;
}

export const PriceStatSwitch = (props: Props) => {
    const {location} = props;
    const {rooms, setRooms, priceStat, setPriceStat} = usePricesContext();

    const isMedianDisabled = !isAllRooms(rooms);

    return (
        <Tabs
            variant="pill"
            fullWidth
            className={tabsStyle}
            titleClassName={titleStyle}
            value={priceStat}
            onChange={(value) => {
                if (value === priceStat || (value === "median" && isMedianDisabled)) {
                    return;
                }

                setPriceStat(value);
                trackPricesCityButtonClick({
                    buttonName: "rp_apartment_prices_price_stat",
                    value: PRICE_STAT_TABS.find((tab) => tab.value === value)?.title ?? value,
                    location
                });
            }}
            tabs={[...PRICE_STAT_TABS]}
            customRenderer={(tab, titleElement) => {
                if (tab.value !== "median" || !isMedianDisabled) {
                    return titleElement;
                }

                return (
                    <DsTooltip
                        popover={
                            <Message type="info">
                                <Message.Content>
                                    Aby wybrać Medianę,{" "}
                                    <button type="button" className={switchLinkStyle} onClick={() => setRooms(ALL_ROOMS)}>
                                        przełącz liczbę pokoi na Wszystkie
                                    </button>
                                    .
                                </Message.Content>
                            </Message>
                        }
                        type="info"
                        placement="top"
                        interactive
                    >
                        {({refs, getReferenceProps}) => (
                            <div ref={refs.setReference} className={disabledTabStyle} {...getReferenceProps()}>
                                <div className={disabledTabInnerStyle}>{titleElement}</div>
                            </div>
                        )}
                    </DsTooltip>
                );
            }}
        />
    );
};

// Stretches to the full row only below xs - from xs up the switch keeps its natural width next to the rooms select.
const tabsStyle = css({
    w: "100%",

    xs: {
        w: "auto"
    }
});

// fullWidth narrows the pill padding; from xs up it's restored to the default pill padding (the module CSS needs !important to be overridden).
const titleStyle = css({
    xs: {
        px: "3.45rem !important"
    }
});

const disabledTabStyle = css({
    flex: 1,
    opacity: 0.4,
    cursor: "not-allowed"
});

const disabledTabInnerStyle = css({
    pointerEvents: "none"
});

const switchLinkStyle = css({
    display: "inline",
    padding: 0,
    border: "none",
    background: "none",
    font: "inherit",
    color: "inherit",
    textDecoration: "underline",
    cursor: "pointer"
});
import {css} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {Message} from "@pg-design/message-module";
import {Tabs} from "@pg-design/tabs-module";

import {ALL_ROOMS, isAllRooms} from "../constants/rcn_rooms_filter";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {trackPricesCityButtonClick} from "../tracking/track_prices_city_button_click";
import {usePricesContext} from "./PricesContextFilterProvider";

const PRICE_STAT_TABS = [
    {title: "Średnia", value: "average"},
    {title: "Mediana", value: "median"}
] as const;

interface Props {
    location: PricesCityAnalyticsLocation;
}

export const PriceStatSwitch = (props: Props) => {
    const {location} = props;
    const {rooms, setRooms, priceStat, setPriceStat} = usePricesContext();

    const isMedianDisabled = !isAllRooms(rooms);

    return (
        <Tabs
            variant="pill"
            fullWidth
            className={tabsStyle}
            titleClassName={titleStyle}
            value={priceStat}
            onChange={(value) => {
                if (value === priceStat || (value === "median" && isMedianDisabled)) {
                    return;
                }

                setPriceStat(value);
                trackPricesCityButtonClick({
                    buttonName: "rp_apartment_prices_price_stat",
                    value: PRICE_STAT_TABS.find((tab) => tab.value === value)?.title ?? value,
                    location
                });
            }}
            tabs={[...PRICE_STAT_TABS]}
            customRenderer={(tab, titleElement) => {
                if (tab.value !== "median" || !isMedianDisabled) {
                    return titleElement;
                }

                return (
                    <DsTooltip
                        popover={
                            <Message type="info">
                                <Message.Content>
                                    Aby wybrać Medianę,{" "}
                                    <button type="button" className={switchLinkStyle} onClick={() => setRooms(ALL_ROOMS)}>
                                        przełącz liczbę pokoi na Wszystkie
                                    </button>
                                    .
                                </Message.Content>
                            </Message>
                        }
                        type="info"
                        placement="top"
                        interactive
                    >
                        {({refs, getReferenceProps}) => (
                            <div ref={refs.setReference} className={disabledTabStyle} {...getReferenceProps()}>
                                <div className={disabledTabInnerStyle}>{titleElement}</div>
                            </div>
                        )}
                    </DsTooltip>
                );
            }}
        />
    );
};

// Stretches to the full row only below xs - from xs up the switch keeps its natural width next to the rooms select.
const tabsStyle = css({
    w: "100%",

    xs: {
        w: "auto"
    }
});

// fullWidth narrows the pill padding; from xs up it's restored to the default pill padding (the module CSS needs !important to be overridden).
const titleStyle = css({
    xs: {
        px: "3.45rem !important"
    }
});

const disabledTabStyle = css({
    flex: 1,
    opacity: 0.4,
    cursor: "not-allowed"
});

const disabledTabInnerStyle = css({
    pointerEvents: "none"
});

const switchLinkStyle = css({
    display: "inline",
    padding: 0,
    border: "none",
    background: "none",
    font: "inherit",
    color: "inherit",
    textDecoration: "underline",
    cursor: "pointer"
});
